/**
 *  Returns true when the value is not an empty string
 */
const notEmpty = (value: any) => {
	return value !== '';
};

export default notEmpty;
